type BodyWithLock = HTMLBodyElement & {
  __lockY?: number
  __lockCount?: number
}

function getBody(): BodyWithLock {
  return document.body as BodyWithLock
}

export function lockBodyScroll() {
  const body = getBody()
  const currentCount = body.__lockCount ?? 0
  if (currentCount > 0) {
    body.__lockCount = currentCount + 1
    return
  }

  const y = window.scrollY
  body.style.position = 'fixed'
  body.style.top = `-${y}px`
  body.style.left = '0'
  body.style.right = '0'
  body.__lockY = y
  body.__lockCount = 1
}

export function unlockBodyScroll() {
  const body = getBody()
  const currentCount = body.__lockCount ?? 0
  if (currentCount > 1) {
    body.__lockCount = currentCount - 1
    return
  }
  body.__lockCount = 0

  const y = body.__lockY ?? 0
  body.style.position = ''
  body.style.top = ''
  body.style.left = ''
  body.style.right = ''
  body.__lockY = undefined
  window.scrollTo(0, y)
}
